/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAwsSsmDocuments extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAwsSsmDocuments");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAwsSsmDocuments.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAwsSsmDocuments>): BackgroundJobPayloadForAwsSsmDocuments {
        let obj = Object.assign(new BackgroundJobPayloadForAwsSsmDocuments(), model);
        BackgroundJobPayloadForAwsSsmDocuments.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAwsSsmDocuments>): BackgroundJobPayloadForAwsSsmDocuments {
        if (!model) return null;
        return BackgroundJobPayloadForAwsSsmDocuments.newInstance(<BackgroundJobPayloadForAwsSsmDocuments> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAwsSsmDocuments) {
        if (!obj) return;

        models.BackgroundJobPayloadForAwsSsmDocuments.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAwsSsmDocuments): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAwsSsmDocuments.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Master Account id for the background job need to processed
     */
    master_account_id: string;

    /**
     * Cloud Account id for the background job need to processed
     */
    cloud_account_id: string;

    /**
     * Type of the document sync
     */
    sync_type: models.AwsSsmDocumentSyncType;

}
